import {inlineError} from '@s-ui/decorators'
import {Service} from '@s-ui/domain'

/**
 * @implements Service
 */
export class GetSearchPaginationUrlAdsService extends Service {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Object} deps.config
   * @param {FromSearchJSONToUrlVOMapper} deps.fromSearchJSONToUrlVOMapper
   * @param {GetUrlService} deps.getUrlService
   * @param {FromPageNameToConstantNamingPageName} deps.fromPageNameToConstantNamingPageName
   */
  constructor({config, fromPageNameToConstantNamingPageName, fromSearchJSONToUrlVOMapper, getUrlService}) {
    super()

    this._config = config
    this._pageConfig = this._config.get('page')
    this._urlPaginationParam = `${this._pageConfig.AMPERSAND_MARK}${this._pageConfig.PAGINATION_PATTERN}`
    this._fromSearchJSONToUrlVOMapper = fromSearchJSONToUrlVOMapper
    this._fromPageNameToConstantNamingPageName = fromPageNameToConstantNamingPageName
    this._getUrlService = getUrlService
    this._defaultPageName = 'ads-list'
  }

  /**
   * @param {Object} params
   * @param {Object} data.searchRequestObjectVO
   * @param {String} data.pageName
   * @param {String} data.dealerSlug
   * @return {Promise<[Error, UrlValueObject]>}
   */
  @inlineError
  async execute({dealerSlug, listingSectionId, pageName = this._defaultPageName, searchRequestObjectVO, section}) {
    const search = searchRequestObjectVO.toJSON()

    const searchQuery = await this._fromSearchJSONToUrlVOMapper.setParams({...search, listingSectionId}).map()

    const {categoryId, offerTypeId} = search

    return this._getUrlService.execute({
      listingSectionId,
      pageName,
      params: {categoryId, dealerSlug, offerTypeId, section},
      query: {...searchQuery, pg: undefined}
    })
  }
}
